import { type CSSProperties } from 'react';
import classNames from 'classnames';

import { Image } from '@jsmdg/yoshi';
import { type DynamicYieldCampaign } from '../../../../shared/types';
import styles from './DynamicYieldHeaderBanner.module.scss';

type DynamicYieldHeaderBannerProps = {
    readonly creative: DynamicYieldCampaign;
};

type CSSVariables = CSSProperties & {
    ['--dy-mobile-height']?: string;
    ['--dy-desktop-height']?: string;
};
const DynamicYieldHeaderBanner = ({ creative }: DynamicYieldHeaderBannerProps): JSX.Element => {
    const { analyticsMetadata, data } = creative;

    const style: CSSVariables = {
        '--dy-mobile-height': data['Mobile Height'],
        '--dy-desktop-height': data['Desktop Height'],
    };

    return (
        <div
            id={
                data['Mobile Height'] && data['Desktop Height'] ? 'dynamic-yield-header-banner' : ''
            }
            style={style}
            className={classNames(styles.dyBanner, 'dy-campaign-wrapper')}
            data-dy-campaign-id={analyticsMetadata.campaignId}
            data-dy-campaign-name={analyticsMetadata.campaignName}
            data-dy-experience-id={analyticsMetadata.experienceId}
            data-dy-experience-name={analyticsMetadata.experienceName}
            data-dy-variation-id={analyticsMetadata.variationId}
            data-dy-variation-name={analyticsMetadata.variationName}
        >
            {data.imgixImage && (
                <Image
                    src={data.imgixImage.src}
                    alt={creative.data['Image Alt'] ?? ''}
                    className="w-100 h-100"
                    srcSet={data.imgixImage.srcset}
                    sizes={data.imgixImage.sizes}
                />
            )}
        </div>
    );
};

export { DynamicYieldHeaderBanner };
